<template>
    <div class="p-4 bg-white rounded-lg shadow-sm space-y-4">
        <h2 class="text-lg font-semibold">
            RedesignBaseTree — Demo
        </h2>


        <RedesignBaseTree
            v-model="checkedKeys"
            :data="treeData"
            node-key="id"
            highlight-current
            show-checkbox
            accordion
            @node-click="onNodeClick"
            @check-change="onCheckChange"
        >
            <template #label>
                <span class="text-sm font-medium text-gray-800">User Access Tree</span>
            </template>

            <template #node="{ data }">
                <div class="flex items-center gap-2">
                    <span>{{ data.name }}</span>
                </div>
            </template>
        </RedesignBaseTree>
    </div>
</template>

<script setup lang="ts">
import RedesignBaseTree from '@/components/RedesignBaseComponents/Inputs/RedesignBaseTree.vue'


import { ref } from 'vue'

// Hardcoded tree data
const checkedKeys = ref([ 3 ])

const treeData = ref([
    {
        id: 1,
        name: 'Admin Panel',
        children: [
            {
                id: 2,
                name: 'Users',
                children: [
                    {
                        id: 3,
                        name: 'View Users'
                    },
                    {
                        id: 4,
                        name: 'Edit Users'
                    },
                ],
            },
            {
                id: 5,
                name: 'Roles',
                children: [
                    {
                        id: 6,
                        name: 'View Roles'
                    },
                    {
                        id: 7,
                        name: 'Edit Roles'
                    },
                ],
            },
        ],
    },
    {
        id: 8,
        name: 'Settings',
        children: [
            {
                id: 9,
                name: 'General Settings'
            },
            {
                id: 10,
                name: 'Security Settings'
            },
        ],
    },
])

// Tree event handlers
function onNodeClick ({ data, node }) {
    console.log('Node clicked:', data, node)
}

function onCheckChange ({ data, checked }) {
    console.log(
        `Node "${data?.name}" is now ${checked ? 'checked' : 'unchecked'}`
    )
}
</script>

<style scoped>
</style>

